var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExchangeIcon = function SvgExchangeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 52 53"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m18.224 8.084-6.907 6.906h35.809v3.25H11.344l6.907 6.906-2.298 2.298L7.408 18.9l-.014.014-2.298-2.298 10.83-10.83zM41.55 38.01H5.77v-3.25h35.808l-6.907-6.906 2.298-2.298 10.83 10.83-2.298 2.298-.014-.014-8.545 8.545-2.298-2.298z"
  })));
};
export default SvgExchangeIcon;